/**
 * @generated SignedSource<<c35b2119de56a11ada68598cd052394f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ConfigurationBankAccountsViewQuery$variables = Record<PropertyKey, never>;
export type ConfigurationBankAccountsViewQuery$data = {
  readonly bankAccounts: ReadonlyArray<{
    readonly anchorBalance: number;
    readonly anchorDate: any;
    readonly bankAccountIdentifier: string;
    readonly id: string;
    readonly name: string;
  }>;
};
export type ConfigurationBankAccountsViewQuery = {
  response: ConfigurationBankAccountsViewQuery$data;
  variables: ConfigurationBankAccountsViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "BankAccount",
    "kind": "LinkedField",
    "name": "bankAccounts",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "bankAccountIdentifier",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "anchorDate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "anchorBalance",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ConfigurationBankAccountsViewQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ConfigurationBankAccountsViewQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "b79c3e9002ded0af273ec89ec07007cf",
    "id": null,
    "metadata": {},
    "name": "ConfigurationBankAccountsViewQuery",
    "operationKind": "query",
    "text": "query ConfigurationBankAccountsViewQuery {\n  bankAccounts {\n    id\n    bankAccountIdentifier\n    name\n    anchorDate\n    anchorBalance\n  }\n}\n"
  }
};
})();

(node as any).hash = "0439b014e029f4879b524dfea536fbed";

export default node;
